/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssignStakeholdersDto } from '../models';
// @ts-ignore
import type { AssignStakeholdersResultDto } from '../models';
// @ts-ignore
import type { CreateQuestionDto } from '../models';
// @ts-ignore
import type { DoubleMaterialityIroTypeEnum } from '../models';
// @ts-ignore
import type { DoubleMaterialityQuestionsControllerGetAllQuestions200Response } from '../models';
// @ts-ignore
import type { DoubleMaterialityStakeholderType } from '../models';
// @ts-ignore
import type { GenerateQuestionsDto } from '../models';
// @ts-ignore
import type { QuestionDto } from '../models';
// @ts-ignore
import type { UpdateQuestionDto } from '../models';
/**
 * DoubleMaterialityQuestionsApi - axios parameter creator
 * @export
 */
export const DoubleMaterialityQuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {AssignStakeholdersDto} assignStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerAssignStakeholder: async (id: string, assignStakeholdersDto: AssignStakeholdersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerAssignStakeholder', 'id', id)
            // verify required parameter 'assignStakeholdersDto' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerAssignStakeholder', 'assignStakeholdersDto', assignStakeholdersDto)
            const localVarPath = `/api/dm/questions/{id}/stakeholders`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignStakeholdersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateQuestionDto} createQuestionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerCreateQuestion: async (createQuestionDto: CreateQuestionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createQuestionDto' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerCreateQuestion', 'createQuestionDto', createQuestionDto)
            const localVarPath = `/api/dm/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerDeleteQuestion: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerDeleteQuestion', 'id', id)
            const localVarPath = `/api/dm/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateQuestionsDto} generateQuestionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerGenerateQuestions: async (generateQuestionsDto: GenerateQuestionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateQuestionsDto' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerGenerateQuestions', 'generateQuestionsDto', generateQuestionsDto)
            const localVarPath = `/api/dm/questions/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateQuestionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {Array<DoubleMaterialityStakeholderType>} [stakeholderType] Values: internal&#x3D;Internal, external&#x3D;External
         * @param {Array<DoubleMaterialityIroTypeEnum>} [iro] Values: 0&#x3D;Impact, 1&#x3D;Risk, 2&#x3D;Opportunity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerGetAllQuestions: async (year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, stakeholderType?: Array<DoubleMaterialityStakeholderType>, iro?: Array<DoubleMaterialityIroTypeEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerGetAllQuestions', 'year', year)
            const localVarPath = `/api/dm/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (stakeholderType) {
                localVarQueryParameter['stakeholderType'] = stakeholderType;
            }

            if (iro) {
                localVarQueryParameter['iro'] = iro;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerGetForStakeholder: async (stakeholderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stakeholderId' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerGetForStakeholder', 'stakeholderId', stakeholderId)
            const localVarPath = `/api/dm/questions/for-stakeholder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stakeholderId !== undefined) {
                localVarQueryParameter['stakeholderId'] = stakeholderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerGetQuestionById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerGetQuestionById', 'id', id)
            const localVarPath = `/api/dm/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerSetAssignedToAll: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerSetAssignedToAll', 'id', id)
            const localVarPath = `/api/dm/questions/{id}/assigned-to-all`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AssignStakeholdersDto} assignStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerUnassignStakeholder: async (id: string, assignStakeholdersDto: AssignStakeholdersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerUnassignStakeholder', 'id', id)
            // verify required parameter 'assignStakeholdersDto' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerUnassignStakeholder', 'assignStakeholdersDto', assignStakeholdersDto)
            const localVarPath = `/api/dm/questions/{id}/stakeholders`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignStakeholdersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuestionDto} updateQuestionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerUpdateQuestion: async (id: string, updateQuestionDto: UpdateQuestionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerUpdateQuestion', 'id', id)
            // verify required parameter 'updateQuestionDto' is not null or undefined
            assertParamExists('doubleMaterialityQuestionsControllerUpdateQuestion', 'updateQuestionDto', updateQuestionDto)
            const localVarPath = `/api/dm/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DoubleMaterialityQuestionsApi - functional programming interface
 * @export
 */
export const DoubleMaterialityQuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DoubleMaterialityQuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AssignStakeholdersDto} assignStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerAssignStakeholder(id: string, assignStakeholdersDto: AssignStakeholdersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignStakeholdersResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerAssignStakeholder(id, assignStakeholdersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerAssignStakeholder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateQuestionDto} createQuestionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerCreateQuestion(createQuestionDto: CreateQuestionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerCreateQuestion(createQuestionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerCreateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerDeleteQuestion(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerDeleteQuestion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerDeleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateQuestionsDto} generateQuestionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerGenerateQuestions(generateQuestionsDto: GenerateQuestionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuestionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerGenerateQuestions(generateQuestionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerGenerateQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {Array<DoubleMaterialityStakeholderType>} [stakeholderType] Values: internal&#x3D;Internal, external&#x3D;External
         * @param {Array<DoubleMaterialityIroTypeEnum>} [iro] Values: 0&#x3D;Impact, 1&#x3D;Risk, 2&#x3D;Opportunity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerGetAllQuestions(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, stakeholderType?: Array<DoubleMaterialityStakeholderType>, iro?: Array<DoubleMaterialityIroTypeEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleMaterialityQuestionsControllerGetAllQuestions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerGetAllQuestions(year, search, orderBy, orderDirection, pageNumber, pageSize, stakeholderType, iro, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerGetAllQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerGetForStakeholder(stakeholderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuestionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerGetForStakeholder(stakeholderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerGetForStakeholder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerGetQuestionById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerGetQuestionById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerGetQuestionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerSetAssignedToAll(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerSetAssignedToAll(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerSetAssignedToAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {AssignStakeholdersDto} assignStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerUnassignStakeholder(id: string, assignStakeholdersDto: AssignStakeholdersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerUnassignStakeholder(id, assignStakeholdersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerUnassignStakeholder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuestionDto} updateQuestionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionsControllerUpdateQuestion(id: string, updateQuestionDto: UpdateQuestionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionsControllerUpdateQuestion(id, updateQuestionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerUpdateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DoubleMaterialityQuestionsApi - factory interface
 * @export
 */
export const DoubleMaterialityQuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DoubleMaterialityQuestionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AssignStakeholdersDto} assignStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerAssignStakeholder(id: string, assignStakeholdersDto: AssignStakeholdersDto, options?: RawAxiosRequestConfig): AxiosPromise<AssignStakeholdersResultDto> {
            return localVarFp.doubleMaterialityQuestionsControllerAssignStakeholder(id, assignStakeholdersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateQuestionDto} createQuestionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerCreateQuestion(createQuestionDto: CreateQuestionDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDto> {
            return localVarFp.doubleMaterialityQuestionsControllerCreateQuestion(createQuestionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerDeleteQuestion(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialityQuestionsControllerDeleteQuestion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenerateQuestionsDto} generateQuestionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerGenerateQuestions(generateQuestionsDto: GenerateQuestionsDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<QuestionDto>> {
            return localVarFp.doubleMaterialityQuestionsControllerGenerateQuestions(generateQuestionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {Array<DoubleMaterialityStakeholderType>} [stakeholderType] Values: internal&#x3D;Internal, external&#x3D;External
         * @param {Array<DoubleMaterialityIroTypeEnum>} [iro] Values: 0&#x3D;Impact, 1&#x3D;Risk, 2&#x3D;Opportunity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerGetAllQuestions(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, stakeholderType?: Array<DoubleMaterialityStakeholderType>, iro?: Array<DoubleMaterialityIroTypeEnum>, options?: RawAxiosRequestConfig): AxiosPromise<DoubleMaterialityQuestionsControllerGetAllQuestions200Response> {
            return localVarFp.doubleMaterialityQuestionsControllerGetAllQuestions(year, search, orderBy, orderDirection, pageNumber, pageSize, stakeholderType, iro, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerGetForStakeholder(stakeholderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<QuestionDto>> {
            return localVarFp.doubleMaterialityQuestionsControllerGetForStakeholder(stakeholderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerGetQuestionById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDto> {
            return localVarFp.doubleMaterialityQuestionsControllerGetQuestionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerSetAssignedToAll(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialityQuestionsControllerSetAssignedToAll(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {AssignStakeholdersDto} assignStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerUnassignStakeholder(id: string, assignStakeholdersDto: AssignStakeholdersDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialityQuestionsControllerUnassignStakeholder(id, assignStakeholdersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuestionDto} updateQuestionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionsControllerUpdateQuestion(id: string, updateQuestionDto: UpdateQuestionDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDto> {
            return localVarFp.doubleMaterialityQuestionsControllerUpdateQuestion(id, updateQuestionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DoubleMaterialityQuestionsApi - object-oriented interface
 * @export
 * @class DoubleMaterialityQuestionsApi
 * @extends {BaseAPI}
 */
export class DoubleMaterialityQuestionsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {AssignStakeholdersDto} assignStakeholdersDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerAssignStakeholder(id: string, assignStakeholdersDto: AssignStakeholdersDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerAssignStakeholder(id, assignStakeholdersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateQuestionDto} createQuestionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerCreateQuestion(createQuestionDto: CreateQuestionDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerCreateQuestion(createQuestionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerDeleteQuestion(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerDeleteQuestion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenerateQuestionsDto} generateQuestionsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerGenerateQuestions(generateQuestionsDto: GenerateQuestionsDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerGenerateQuestions(generateQuestionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} year Reporting year for the double materiality data
     * @param {string | null} [search] 
     * @param {string | null} [orderBy] 
     * @param {string | null} [orderDirection] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {Array<DoubleMaterialityStakeholderType>} [stakeholderType] Values: internal&#x3D;Internal, external&#x3D;External
     * @param {Array<DoubleMaterialityIroTypeEnum>} [iro] Values: 0&#x3D;Impact, 1&#x3D;Risk, 2&#x3D;Opportunity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerGetAllQuestions(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, stakeholderType?: Array<DoubleMaterialityStakeholderType>, iro?: Array<DoubleMaterialityIroTypeEnum>, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerGetAllQuestions(year, search, orderBy, orderDirection, pageNumber, pageSize, stakeholderType, iro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stakeholderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerGetForStakeholder(stakeholderId: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerGetForStakeholder(stakeholderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerGetQuestionById(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerGetQuestionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerSetAssignedToAll(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerSetAssignedToAll(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {AssignStakeholdersDto} assignStakeholdersDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerUnassignStakeholder(id: string, assignStakeholdersDto: AssignStakeholdersDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerUnassignStakeholder(id, assignStakeholdersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateQuestionDto} updateQuestionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionsApi
     */
    public doubleMaterialityQuestionsControllerUpdateQuestion(id: string, updateQuestionDto: UpdateQuestionDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionsApiFp(this.configuration).doubleMaterialityQuestionsControllerUpdateQuestion(id, updateQuestionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

